import { writable } from 'svelte/store'



const visible = writable(false)
export { visible as openai_visible_store }

const openai_limit_reached_store = writable(false)
export { openai_limit_reached_store }


export const openai_tokens_store = writable(0)